import api from './api'

const getById = (planId, payments = false) =>
  api.billing
    .get(`users/me/user-plans/${planId}`, { params: { payments } })
    .then(res => res.data)

const getAll = () =>
  api.billing
    .get(`users/me/user-plans`, { params: { payments: true } })
    .then(res => res.data)

const deleteUserPlan = planId =>
  api.billing.delete(`users/me/user-plans/${planId}`).then(res => res.data)

const clusters = {
  getPlans: () =>
    api.billing
      .get('plans', {
        params: {
          serviceTypes: 'cluster'
        }
      })
      .then(res => res.data)
      .catch(() => [])
}

const nodes = {
  getPlans: () =>
    api.billing
      .get('plans', {
        params: {
          serviceTypes: 'nodes'
        }
      })
      .then(res => res.data)
      .catch(() => []),

  getRenewPlans: planId =>
    api.billing
      .get(`plans/${planId}/renew-target`, {
        params: {
          serviceTypes: 'nodes'
        }
      })
      .then(res => res.data),

  createUserPlan: ({ planId, metadata }) =>
    api.billing
      .post(`users/me/plans/${planId}/user-plans`, { metadata })
      .then(res => res.data),

  renewUserPlan: ({ planId, activeUserPlanId }) =>
    api.billing
      .post(`users/me/user-plans/${activeUserPlanId}/renew`, {
        planId
      })
      .then(res => res.data)
}

export default {
  deleteUserPlan,
  clusters,
  getById,
  getAll,
  nodes
}
